import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';
import { useSelector } from 'react-redux';
import { selectSelectedItem } from '@reducers/machines';
import { selectTimePeriod } from '@reducers/params';
import { PERFORMANCE_MAIN_SCREEN } from '@v2/pages/performance/navigation';
import { MachinesScreen } from '@v2/pages/machines/common/enums';
import { useHandleBottomSheetActions } from '@v2/pages/common/hooks/useHandleBottomSheetActions';

export const useManageOeeTodayBlock = () => {
  const navigation = useNavigation<any>();
  const selectedItem = useSelector(selectSelectedItem);
  const timePeriod = useSelector(selectTimePeriod);
  const { openScreenInsideBottomSheet } = useHandleBottomSheetActions();

  const id = selectedItem?.id;

  const handlePress = useCallback(() => {
    const navigationAction = () =>
      navigation?.navigate(PERFORMANCE_MAIN_SCREEN, {
        screen: `${PERFORMANCE_MAIN_SCREEN}${MachinesScreen.UTILIZATION}`,
        params: { id, timePeriod },
      });
    openScreenInsideBottomSheet({ navigationAction, bottomSheetId: PERFORMANCE_MAIN_SCREEN });
  }, [navigation, id, timePeriod]);

  return { handlePress };
};
